import { find, NotVoid } from "lodash";
import create from "zustand";
import { devtools } from "zustand/middleware";
import { API_SLUGS } from "../constants";
import { axiosInstance } from "../services/axios";
const format = require("string-template");

export interface IBreadcrumbState {
    selectedGroup: any;
    selectedProject: any;
    groups: any[];
    projects: any[];
    groupsLoading: boolean;
    projectsLoading: boolean;
    groupsTyping: boolean;
    projectsTyping: boolean;
    isBreadcrumbStable: boolean;
    fetchGroups: (searchQuery?: string | null) => Promise<void>;
    fetchProjects: (searchQuery?: string | null) => Promise<void>;
    changeGroup: (id?: string| null) => Promise<void>;
    changeProject: (id?: string| null, remove?: boolean) => void;
    overrideBreadcrumb: any
    setOverrideBreadcrumb: (data: any) => NotVoid
    
}

export const useBreadcrumbState = create(devtools<IBreadcrumbState>((set) => ({
    selectedGroup: null,
    selectedProject: null,
    groups: [],
    projects: [],
    groupsLoading: false,
    projectsLoading: false,
    groupsTyping: false,
    projectsTyping: false,
    isBreadcrumbStable: false,

    fetchGroups: async (searchQuery = null) => {
        set({ groupsLoading: true });
        try {
            const response = await axiosInstance.get(`/group?limit=20${searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : ''}`);

            let newGroups =response.data?.groups ||[]
            if(newGroups?.length>=20){
                newGroups= [...newGroups, {id:"SEARCH_FOR_MORE", name: "zzz"}]
            }

            set({ groups: newGroups, groupsLoading: false });
            if(!useBreadcrumbState.getState().selectedGroup){
                await useBreadcrumbState.getState().changeGroup()
            }
        } catch (error) {
            console.error("Error fetching groups:", error);
            set({ groups: [], groupsLoading: false });
        }
    },

    fetchProjects: async (searchQuery = null) => {
        const currentSelectedGroup = useBreadcrumbState.getState().selectedGroup
        if(!currentSelectedGroup) return
        set({ projectsLoading: true });
        try {
            const response = await axiosInstance.get(`${format(API_SLUGS.PROJECTS_BY_GROUP, { groupId: currentSelectedGroup?.id })}&limit=20${searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : ''}`);
            

            let newProjects =response.data?.projects ||[]
            if(newProjects?.length>=20){
                newProjects= [...newProjects, {id:"SEARCH_FOR_MORE", name:"zzz"}]
            }
            set({ projects: newProjects, projectsLoading: false });
            if(!useBreadcrumbState.getState().selectedProject){
                await useBreadcrumbState.getState().changeProject()
                set({isBreadcrumbStable: true}) 
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
            set({ projects: [], projectsLoading: false });
        }
    },

    changeGroup: async(id) => {
        const newGroupId = id || useBreadcrumbState.getState().overrideBreadcrumb?.group?.id  || localStorage.getItem("groupId") || "";
        const group = find(useBreadcrumbState.getState().groups, { id: newGroupId });
        if (group) {
            if(useBreadcrumbState.getState().overrideBreadcrumb?.group?.id!==newGroupId){
                localStorage.setItem("groupId", newGroupId);
            }
            
            set({ selectedGroup: group , selectedProject: null});
        }else if (newGroupId){
            try {
                const response = await axiosInstance.get(`/group/${newGroupId}`);
    
                let newGroup =response.data
    
                set({ selectedGroup: newGroup  , selectedProject: null });
            } catch (error) {
                console.error("Error fetching groups:", error);
                
            }
            
        }else if(useBreadcrumbState.getState().groups?.[0]){
            localStorage.setItem("groupId", useBreadcrumbState.getState().groups?.[0]?.id);
            
            
            set({ selectedGroup: useBreadcrumbState.getState().groups?.[0] , selectedProject: null });
        }
    },

    changeProject: (id, remove = false) => {
        
        if (remove) {
            localStorage.removeItem("projectId");
            set({ selectedProject: null });
            return;
        }
        const newProjectId = id || useBreadcrumbState.getState().overrideBreadcrumb?.project?.id  ||  localStorage.getItem("projectId") || "";
        const project = find(useBreadcrumbState.getState().projects, { id: newProjectId });
        if (project ) {
            if(useBreadcrumbState.getState().overrideBreadcrumb?.project?.id!==newProjectId){
                localStorage.setItem("projectId", newProjectId);
            }
            
            set({ selectedProject: project });
        }
        
        
        
    },

    
    overrideBreadcrumb: { group:null, project: null },
    setOverrideBreadcrumb: (data: any) => {
        set((state: IBreadcrumbState) => {
            
            let newBreadcrumb:any = {}   
            newBreadcrumb.project = data?.project?.id? data?.project: null
            newBreadcrumb.group = data?.group?.id? data?.group: null

            return { ...state, overrideBreadcrumb: { ...newBreadcrumb }, selectedGroup: newBreadcrumb?.group, selectedProject: newBreadcrumb?.project }
        })
    },
    
})));
